import { Component, HostBinding, inject, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { fieldPropertyGenerator } from '@app/api/core/utils/fieldproperty-generator.utils';
import { FieldPropertyDescriptor } from '@app/shared/dynamic-form/util/descriptor/descriptor-types';
import { createDescriptorMap } from '@app/shared/dynamic-form/util/descriptor/descriptor-util';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Notiz } from '@o30/entities';
import { noop } from 'rxjs';
import { DescriptorMap } from '../../../dynamic-form/descriptor-map.model';
import { DynamicComponent } from '../../../dynamic-form/dynamic-component.model';
import { DynamicFormComponent } from '../../../dynamic-form/dynamic-form.component';
import { ValidatorConfig } from '../../../dynamic-form/validator-config.model';
import { FormatDatePipe } from '../../../pipes/formatdate.pipe';
import { DataService } from '../../../services/data/data.service';
import { MessageService } from '../../../services/ui/message/message.service';
import { BasicTextareaComponent } from '../basic-textarea/basic-textarea.component';

// TODO notiz is not mandatory right now
@UntilDestroy()
@Component({
  selector:    'app-notiz',
  templateUrl: './notiz.component.html',
  styleUrls:   [],
  standalone:  true,
  imports:     [DynamicFormComponent]
})
export class NotizComponent implements DynamicComponent, // TODO: generic component
                                       OnInit {
  dataService = inject(DataService);
  messageService = inject(MessageService);

  @ViewChild(DynamicFormComponent, {static: true})
  private dynamicForm: DynamicFormComponent<Notiz>;

  data: Notiz;
  descriptorMap: DescriptorMap<Notiz>;

  formControl: UntypedFormControl;

  @Input() styleClass: string;

  @HostBinding('class') get styleClasses(): string {
    let c = 'o30-form-control';
    if (this.styleClass) {
      c += ' ' + this.styleClass;
    }
    return c.trim();
  }

  ngOnInit() {
    if (this.formControl.value) {
      this.data = JSON.parse(JSON.stringify(this.formControl.value));
      this.init();
    }
    this.formControl.valueChanges.pipe(
        untilDestroyed(this))
      .subscribe((newValue) => {
        this.data = newValue;
      });
  }

  private init() {
    this.setDescriptorMap();
  }

  /*,.-"^"-.,.-"^"-.,.-"^"-.,.-"^"-.,[--DynamicComponent implementation--],.-"^"-.,.-"^"-.,.-"^"-.,.-"^ */

  dncInit(formControl: UntypedFormControl, validators: ValidatorConfig) {
    this.formControl = formControl;
    this.dynamicForm.valueChange$.pipe(
        untilDestroyed(this))
      .subscribe(() => {
        this.formControl.setValue(this.data);
      });
  }

  focus() {
    // focus not needed
  }

  markAsTouched() {
    this.dynamicForm.markAllAsTouched();
  }

  /*,.-"^"-.,.-"^"-.,.-"^"-.,.-"^"-.,[--private--],.-"^"-.,.-"^"-.,.-"^"-.,.-"^ */

  private getLabels() {
    return {
      bearbeitet: 'Bearbeitet',
      text:       'Notiz'
    };
  }

  private setDescriptorMap() {
    const descriptor = {
      dsc: {
        bearbeitet: {
          context:       {
            styleClass:    'full',
            readonly:      true,
            fieldProperty: fieldPropertyGenerator({})
          },
          valueAccessor: {
            get: () => this.data?.bearbeitet?.date ? this.data.bearbeitet.userId + ' ' + new FormatDatePipe().transform(this.data.bearbeitet.date) : ' - ',
            set: noop
          }
        },
        text:       {
          type:    BasicTextareaComponent,
          context: {styleClass: 'full'}
        }
      }
    } as FieldPropertyDescriptor<Notiz>;
    this.descriptorMap = createDescriptorMap(descriptor, this.data, this.getLabels());
  }
}
